import { validatePassword } from "@/utils/validation";
import { useCallback, useState } from "react";

export const usePasswordValidation = () => {
  const [passwordErrors, setPasswordErrors] = useState<string[]>([]);

  const validatePasswordField = useCallback((password: string) => {
    if (!password.trim()) {
      setPasswordErrors([]);
      return { isValid: true, errors: [] };
    }

    const validation = validatePassword(password);
    setPasswordErrors(validation.isValid ? [] : validation.errors.map(e => e.message));
    return validation;
  }, []);

  const clearPasswordErrors = useCallback(() => {
    setPasswordErrors([]);
  }, []);

  const hasPasswordErrors = passwordErrors.length > 0;

  return {
    passwordErrors,
    validatePasswordField,
    clearPasswordErrors,
    hasPasswordErrors,
  };
};

export default usePasswordValidation; 